import { ApolloClient } from '@apollo/client'
import { actionTypes } from './index'
import createFetchSaga from '@utils/store/createFetchSaga'
import parcelsGetQuery from '@queries/parcelsGetQuery'
import { sagaDebounce } from '@store/helpers'

const fetchList = async (client: ApolloClient<any>, action: Action): Promise<any> => {
  return await client
    .query({ query: parcelsGetQuery, variables: { ...action.payload } })
    .then(({ data }) => ({ data: data?.parcelsGet }))
}

export default function* watch(): Generator {
  if (typeof window === 'undefined') return
  yield sagaDebounce(200, actionTypes.run, createFetchSaga(actionTypes.run, fetchList))
}
